import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`While the L3 emergencies drew global attention, WFP continued its life-saving work in countries facing forgotten crises, using EU funding to respond to massive needs across the globe.`}</p>
    <p><strong parentName="p">{`Sudan`}</strong>{`, a country challenged by climate shocks and protracted conflict, grappled with a worsening economic crisis and widespread unrest in 2019. By the end of the year, 9.3 million people needed humanitarian assistance and 6.2 million people were food insecure.`}</p>
    <p>{`Thanks to funding from donors like the EU, WFP was able to provide food and cash assistance as well as nutrition support to crisis-affected communities, reaching a total of `}<a parentName="p" {...{
        "href": "https://www.wfp.org/operations/annual-country-report/?operation_id=SD02&year=2019#/16000"
      }}>{`3.8 million`}</a>{` beneficiaries in 2019.`}</p>
    <p>{`Decades of complex conflicts combined with a changing climate have posed major challenges for `}<strong parentName="p">{`Afghanistan`}</strong>{`. In 2019, after one of the worst droughts in decades, torrential rains caused severe flooding in many areas of the country, threatening lives and destroying livelihoods. Thanks to donors like the EU, WFP was able to reach more than `}<a parentName="p" {...{
        "href": "https://www.wfp.org/operations/annual-country-report/?operation_id=AF01&year=2019#/14000"
      }}>{`5.5 million`}</a>{` people with emergency assistance.`}</p>
    <p>{`In 2019, for the third consecutive year, `}<strong parentName="p">{`Zimbabwe`}</strong>{` experienced drought – the worst the country has seen in 40 years. As a result of this climate shock, compounded by an economic meltdown, nearly 8 million people were left food insecure. Support from the EU and other donors was crucial in reaching more than `}<a parentName="p" {...{
        "href": "https://www.wfp.org/operations/annual-country-report/?operation_id=ZW01&year=2019#/14860"
      }}>{`1.8 million`}</a>{` people across the country with food and cash assistance.`}</p>
    <p>{`In `}<strong parentName="p">{`Haiti`}</strong>{`, rising prices, a drop in agricultural production and recurrent episodes of social unrest pushed some 3.7 million people into hunger, of which more than 1 million faced severe food insecurity. Thanks to funding from donors like the EU, WFP was able to provide food and cash assistance to nearly 600,000 people across the country in 2019.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      